export default {
  evaluation_list: {
    title: 'Lista de proveedores',
    number_of_companies_answered: 'Enviado: {answered}/{total} Empresas',
    number_of_companies_displayed: 'Mostrar {start}〜{end} / {total} empresas',
    company_name: 'Nombre de empresa',
    status: 'Estado',
    questionnaire: 'Cuestionario',
    plan: 'Plan',
    nothing: 'No se han encontrado resultados',
  },
  evidence_options: {
    all_plan: 'Todos los planes',
    plans_with_vouchers: 'Con evidencia',
    no_voucher_plan: 'Sin evidencia',
  },
  table_headers: {
    company_name: 'Nombre de empresa',
    status: 'Estado',
    esg_rating: 'Calificación ESG',
    esg_score: 'Puntaje ESG',
    environment: 'Medioambiente',
    social: 'Social',
    governance: 'Gobernanza',
    plan: 'Plan',
    questionnaire: 'Cuestionario',
    answer_date: 'Fecha de envío',
    answer_expires_date: 'Fecha límite',
  },
  plan_list: {
    light: 'Plan ligero',
    starter: 'Plan Inicial',
    basic: 'Plan Básico',
    standard: 'Plan Estándar',
    enterprize: 'Plan Empresarial',
  },
}
